export default __webpack_public_path__ + "static/media/H4006.2.e2d0bf04.mp3";